import React, { useState } from 'react';
import { Card, Form } from 'antd';

import AccountingEntriesTable from './AccountingEntriesTable';
import AccountingEventsTable from './AccountingEventsTable';
import ParListSelect from '../ParListSelect';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';

type AccountingProps = {
  objecttype: string;
  objectid: number;
  title?: boolean;
};

const Accounting = (props: AccountingProps) => {
  const { objectid, objecttype, title } = props;

  const [eventType, setEventType] = useState('');
  const [model] = useState('');
  const [accreference, setAccreference] = useState<string | undefined>();

  return (
    <Card
      title={
        !title ? (
          <GetLabel
            label="AccountingEventsTitle"
            style={{ fontWeight: 'bold', paddingLeft: 15 }}
          />
        ) : (
          ''
        )
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      className="p-13"
    >
      <Form.Item>
        <FormInput col xs={24} md={6} comcode="Event" name="Event">
          <ParListSelect
            parcode="ACCEVENT"
            parvalueparent={objecttype}
            value={eventType}
            onChange={setEventType}
          />
        </FormInput>
      </Form.Item>

      <AccountingEventsTable
        objectid={objectid}
        eventtype={eventType}
        objecttype={objecttype}
        onSelect={(accountingEvent) => {
          setAccreference(accountingEvent.accountingreference);
        }}
      />

      {accreference && (
        <AccountingEntriesTable
          objectid={objectid}
          accmodel={model}
          accreference={accreference}
        />
      )}
    </Card>
  );
};

export default Accounting;
